// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__FpP5N","form":"styles_form__g-60l"};